import _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import { createEncryptedAsyncThunk } from "./ticketApiUtils";


export const getMasterDataListFromTicket = createEncryptedAsyncThunk(
  "ticketSystemSlice/getMasterDataListFromTicket",
  "account/GetMasterDataList",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      role_Id: Array.isArray(params.roleId)
        ? params.roleId
        : [Number(params.roleId) || 0],
      masterDatakey: params.masterDatakey || '',
      status: params.status || 1
    }),
  }
);

export const getTicketMasterFromTicket = createEncryptedAsyncThunk(
  "ticketSystemSlice/getTicketMasterFromTicket",
  "account/GetTicketMaster",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      ticketUserId: params.ticketUserId || 0,
      ticketNumber: params.ticketId || '',
      project_name: params.project_name || '',
      projectId: params.projectId || 0,
      developer_userId: params.developer_userId || 0,
      organization_Id: params.organization_Id || 0,
      category: params.category || '',
      type: params.type || '',
      status: params.status || [0,1,2,3,4,5],
      authPwd: params.authPwd || '',
      preLogin: true
    }),
  }
);

export const createTicketFromTicket = createEncryptedAsyncThunk(
  "ticketSystemSlice/createTicketFromTicket",
  "account/CreateTicket",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      category: params.category || '',
      type: params.type || '',
      mobileNo: params.mobileNo || '',
      subject: params.subject || params.otherTextSubject || '',
      project_name: params.project_name || '',
      projectId: params.projectId || 0,
      transaction_id: params.transaction_id || '',
      description: params.description || '',
      request: params.request || '',
      response: params.response || '',
      img_data: params.img_data || '',
      img_type: params.img_type || "",
      authPwd: params.authPwd || '',
      developer_userId: params.developer_userId || 0,
    }),
  }
);

export const updateTicketFromTicket = createEncryptedAsyncThunk(
  "ticketSystemSlice/updateTicketFromTicket",
  "account/UpdateTicket",
  {
    prepareBody: (params) => ({
      // userID: params.currentUser.userGuid,
      complaint_id: params.complaint_id || 0,
      comp_id: params.compId || 0,
      complaint_reply_flag: params.complaint_reply_flag || 0,
      category: params.category || '',
      type: params.type || '',
      mobileNo: params.mobileNo || '',
      subject: params.subject || '',
      status: params.status || 0,
      transaction_id: params.transaction_id || '',
      description: params.description || '',
      replymsgdescription: params.replymsgdescription || '',
      replyStatus: params.replyStatus || 0,
      request: params.request || '',
      response: params.response || '',
      img_data: params.img_data || '',
      img_type: params.img_type || '',
      authPwd: params.authPwd || '',
      resolvedBy: params.resolvedBy || '',
      resolvedRemark: params.resolvedRemark || '',
      developer_userId: params.developer_userId || 0,
    }),
  }
);

export const getCustomerProjectDetailsAction = createEncryptedAsyncThunk(
  "billingSlice/getCustomerProjectDetailsAction",
  'Billing/GetCustomerProjectDetails',
  {
    prepareBody: (params) => ({
      userId: params.currentUser.userGuid,
      projectId: params.projectId || 0,
      customerId: params.customerId || 0,
      organizationId: params.organizationId || 0,
      status: params.status || 0,
      goLiveStatus: params.goLiveStatus || '',
      loginDisable: params.loginDisable || 0,
      projectCode: params.projectCode || '',
      projectDomain: params.projectDomain || '',
      authPwd: params.authPwd || '',
      preLogin: true
    }),
  }
);

export const ticketSystemSlice = createSlice({
  name: "ticketSystemSlice",
  initialState: {
    projectDetails: null
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerProjectDetailsAction.pending, (state) => {
        state.projectDetails = null;
      })
      .addCase(getCustomerProjectDetailsAction.fulfilled, (state, action) => {
        state.projectDetails = null;
        if (action.payload.data && !action.payload.data.message && !_.isEmpty(action.payload.data)) {
          state.projectDetails = _.first(action.payload.data);
        }
      })
      .addCase(getCustomerProjectDetailsAction.rejected, (state) => {
        state.projectDetails = null;
      })
    },
  reducers: {
    clearProjectDetails(state) {
      return { ...state, projectDetails: null };
    },
  },
});
export const {clearProjectDetails} = ticketSystemSlice.actions;

export default ticketSystemSlice.reducer;